import {Types} from "../../../type/Types";

export type AdminValueObject = {
    id: bigint
    email: string
    password: string
    name: string
    createdAt: Date
    modifiedAt: Date | null
    deletedAt: Date | null
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace AdminValueObject {
    export function construct(o: any): AdminValueObject {
        return {
            id: BigInt(o.id),
            email: String(o.email),
            password: String(o.password),
            name: String(o.name),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o))
        }
    }

    export const description: Record<keyof AdminValueObject, string> = {
        id: '기본키',
        email: '이메일',
        password: '비밀번호',
        name: '이름',
        createdAt: '생성일시',
        modifiedAt: '수정일시',
        deletedAt: '삭제일시'
    }
}

